var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortIcon = function SvgSortIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "sortIcon_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sortIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "M11 17.5a.48.48 0 0 1-.356-.144.48.48 0 0 1-.144-.357q0-.212.144-.356A.48.48 0 0 1 11 16.5h2q.213 0 .356.144A.49.49 0 0 1 13.5 17q0 .212-.144.356A.48.48 0 0 1 13 17.5zM4 6.73a.48.48 0 0 1-.356-.143.49.49 0 0 1-.144-.357q0-.212.144-.356A.49.49 0 0 1 4 5.73h16q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .213-.144.356A.49.49 0 0 1 20 6.73zm3 5.385a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356A.49.49 0 0 1 7 11.115h10q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .212-.144.356a.48.48 0 0 1-.356.143z"
  }))));
};
export default SvgSortIcon;